// const BASE_URL = "http://localhost:5000";
//const BASE_URL = "http://159.65.146.120:5000";
const BASE_URL = "https://gcr-api.imedclust.com";

module.exports = {
  BASE_URL
};
